import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const SECTIONS = [
  {
    title: "Titolare del trattamento",
    body: "RUS S.r.l. — CF e P.IVA 18478031000, con sede in Via Maida 89, 00132 Roma (RM). Contatti: tel. 328 787 3805, email Russrl0210@gmail.com, PEC russrl@legalmail.it.",
  },
  {
    title: "Dati che raccogliamo",
    body: "Tramite il modulo di richiesta sopralluogo raccogliamo: nome e cognome, numero di telefono, email (facoltativa), zona/comune dell'immobile, metri quadri, tipo di posa e note sull'abitazione. Tramite il modulo recensioni raccogliamo: nome, indirizzo dell'immobile e testo della recensione. Navigando il sito, solo previo consenso, vengono raccolti dati di utilizzo tramite Google Ads (gtag).",
  },
  {
    title: "Perché li raccogliamo",
    body: "I dati del modulo servono esclusivamente a ricontattarti, fissare il sopralluogo gratuito e preparare il preventivo (base giuridica: esecuzione di misure precontrattuali, art. 6.1.b GDPR). Le recensioni vengono pubblicate sul sito solo dopo verifica dell'indirizzo dell'immobile (base giuridica: consenso, art. 6.1.a GDPR). I dati di Google Ads servono a misurare l'efficacia della pubblicità (base giuridica: consenso).",
  },
  {
    title: "A chi vanno i tuoi dati",
    body: "I dati restano presso il titolare e i fornitori tecnici che ospitano il sito. Con il consenso cookie, alcuni dati di navigazione sono trattati da Google Ireland Ltd secondo le proprie informative. I dati non vengono venduti né ceduti a terzi per altri scopi.",
  },
  {
    title: "Quanto li conserviamo",
    body: "Le richieste di preventivo sono conservate per il tempo necessario a gestire il contatto e comunque non oltre 24 mesi. Le recensioni restano pubblicate finché non ne chiedi la rimozione.",
  },
  {
    title: "I tuoi diritti",
    body: "Ai sensi degli artt. 15-22 GDPR puoi chiedere accesso, rettifica, cancellazione, limitazione e portabilità dei tuoi dati, e revocare il consenso in qualsiasi momento scrivendo a Russrl0210@gmail.com o alla PEC russrl@legalmail.it. Puoi inoltre proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
  },
  {
    title: "Cookie",
    body: "Il sito usa cookie tecnici necessari al funzionamento. I cookie di marketing (Google Ads) vengono attivati solo se premi 'Accetta' nel banner; puoi cambiare scelta cancellando i dati del sito dal browser.",
  },
];

const PrivacyOverlay = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-privacy", handler);
    return () => window.removeEventListener("open-privacy", handler);
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-ink/85 p-4 backdrop-blur-md md:p-8"
          data-testid="privacy-overlay"
        >
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="grain relative max-h-[88vh] w-full max-w-2xl overflow-y-auto rounded-3xl border border-cream/10 bg-walnut p-7 text-cream md:p-10"
          >
            <button
              onClick={() => setOpen(false)}
              data-testid="privacy-close-button"
              aria-label="Chiudi"
              className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-sand transition-colors hover:border-honey hover:text-honey"
            >
              <X size={18} />
            </button>
            <p className="font-sans text-xs font-light uppercase tracking-[0.4em] text-honey">
              Documento legale
            </p>
            <h2 className="mt-3 font-display text-3xl font-medium md:text-4xl">
              Privacy Policy
            </h2>
            <p className="mt-2 font-sans text-xs font-light text-sand/60">
              Informativa ai sensi del Reg. (UE) 2016/679 (GDPR) — ultimo
              aggiornamento: settembre 2026
            </p>
            <div className="mt-8 flex flex-col gap-7">
              {SECTIONS.map((s, i) => (
                <div key={s.title}>
                  <h3 className="font-display text-lg font-medium text-honey">
                    {i + 1}. {s.title}
                  </h3>
                  <p className="mt-2 font-sans text-sm font-light leading-relaxed text-sand/85">
                    {s.body}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PrivacyOverlay;
